import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import {
  postDetails,
  postMultipartDetails,
} from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import EditorField from "../../components/EditorField/EditorField";
import "./addContentForm.css";
import encrypt from "../../utils/helpers/encrypt";
import { validateUploadedFile } from "../../utils/helpers/validateFileUpload";
import { HiArrowSmallLeft } from "react-icons/hi2";
import PageHeader from "../../components/PageHeader/PageHeader";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { useAppDispatch } from "../../store/storeRequests";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { hideToast, showToast } from "../../store/Toast/toast.slice";

const EditContentForm: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isButtonDisableds, setIsButtonDisableds] = useState(false);
  const { tranaingId, contentId } = location.state || {};
  const dispatch = useAppDispatch();
  const [selectedModule, setSelectedModule] = useState<string>("Please Select");
  const [mediaType, setMediaType] = useState<string>("Please Select");
  const [error, setError] = useState<string | null>(null);
  const [file, setFile] = useState<File | null>(null);
  const [contentDesc, setContentDesc] = useState<string>("");
  const [content_name, setContent_name] = useState<string>("");
  const [isValidFile, setIsValidFile] = useState<boolean>(true);
  const [numberInput, setNumberInput] = useState<string>("");

  const [originalContentData, setOriginalContentData] = useState<any>(null);
  const [link, setLink] = useState<string>("");
  const [title, setTitle] = useState<string>("");
  // const [title, setTitle] = useState<string>("");
  const [pollQuestion, setPollQuestion] = useState<string>("");
  const [pollOptions, setPollOptions] = useState<string[]>([""]);
  const [folderData, setFolderData] = useState<
    { id: number; folder_name: string }[]
  >([]);
  const [selectedQuiz, setSelectedQuiz] = useState<number | null>(null);
  const [order, setOrder] = useState<number>(0);
  const [mediaData, setMediaData] = useState<{
    file: File | null;
    description: string;
  }>({ file: null, description: "" });
  const [showResults, setShowResults] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const [contentDescChanged, setContentDescChanged] = useState<boolean>(false);
  const maxLimit = selectedModule === "Media" ? 500 : 2000;
  const fetchContentData = async () => {
    try {
      const response = await postDetails(APIList.GET_CONTENT_BY_ID, {
        id: contentId,
      });

      if (response.statusCode === 200) {
        console.log(response);

        const data = response.data;

        setOriginalContentData(data);

        setSelectedModule(
          data.content_type === "Image" ||
            data.content_type === "Video" ||
            data.content_type === "Pdf" ||
            data.content_type === "Audio"
            ? "Media"
            : data.content_type === "Survey"
            ? "Links"
            : data.content_type === "Text"
            ? "Text"
            : data.content_type === "Poll"
            ? "Live Poll"
            : data.content_type === "Quiz"
            ? "Add Quiz"
            : "Please Select"
        );
        setMediaType(data.content_type || "Please Select");
        // setContentDesc(data.content_desc ? stripHtmlTags(data.content_desc) : "");
        setContentDesc(data.content_desc || "");
        // setCharCount(data.content_desc.length);
        setCharCount(
          data.content_desc ? stripHtmlTags(data.content_desc).length : 0
        );
        setLink(data.link || "");
        setTitle(data.content_name || "");
        setPollQuestion(data.livepollData?.question || "");
        setPollOptions(
          data.livepollData?.optionData?.map(
            (option: { option: any }) => option.option
          ) || [""]
        );
        setSelectedQuiz(data.folder_id || null);
        setOrder(data.order || 0);
        setNumberInput(data.order || 0);
        setShowResults(data.show_result === 1);
      } else {
        setError("Error fetching content data.");
      }
    } catch (err) {
      setError("Error fetching content data.");
      console.error("Error fetching content data:", err);
    }
  };
  // const stripHtmlTags = (html:string) => {
  //   const tempDiv = document.createElement('div');
  //   tempDiv.innerHTML = html;
  //   return tempDiv.textContent || tempDiv.innerText || '';
  // };
  const stripHtmlTags = (input: string) => {
    return input.replace(/<[^>]*>?/gm, "");
  };
  const updateCharCountAndValidation = (data: any) => {
    const plainText = stripHtmlTags(data);
    const sanitizedData = plainText.replace(/&nbsp;/g, " ");
    const charLength = sanitizedData.length;

    if (charLength > 500) {
      setError("Character limit exceeded (500 max)");
    } else {
      setError("");
    }

    setCharCount(charLength);
  };
  const handleEditorChange = (event: any, editor: any) => {
    const data = editor.getData();
    updateCharCountAndValidation(data);
    if (charCount <= 500) {
      setContentDesc(data);
    }
  };
  // const handleEditorChange = (e: any,editor:any) => {
  //   const newValue = e.target.value; // Get the new value from the editor
  //   setContentDesc(newValue); // Update the content description state
  //   const data = editor.getData();
  //   // Calculate the length of the input after stripping any HTML tags
  //   const plainText = stripHtmlTags(newValue);
  //   const charLength = plainText.length;

  //   // Update the character count
  //   setCharCount(charLength);

  //   // Check for character limit
  //   if (charLength > 500) {
  //     setError("Character limit exceeded (500 max)");
  //   } else {
  //     setContentDesc(data);
  //   }
  // };

  // Utility function to strip HTML tags if necessary

  useEffect(() => {
    if (originalContentData) {
      // console.log("Original Content Data Updated:", originalContentData);
    }
  }, [originalContentData]);

  console.log("CONTENT DESCRIPTION", contentDesc);

  const fetchQuizOptions = async () => {
    try {
      const response = await postDetails(APIList.GET_QUIZ_OPTIONS, {});
      if (response.status === 200) {
        console.log(response.data);

        setFolderData(response.data.content_name);
      } else {
        setFolderData(response.data);
      }
    } catch (err) {
      setError("Error fetching quiz options.");
      console.error("Error fetching quiz options:", err);
    }
  };

  useEffect(() => {
    if (contentId) {
      fetchContentData();
    }
  }, [contentId]);

  useEffect(() => {
    if (selectedModule === "Add Quiz") {
      fetchQuizOptions();
    }
  }, [selectedModule]);

  const handleMediaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };

  const handleInputChanges = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    // Prevent negative numbers and non-numeric values
    if (Number(value) >= 0) {
      setNumberInput(value);
    }
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // const normalizeHTML = (html: string) => {
    //   const doc = new DOMParser().parseFromString(html, 'text/html');
    //   return doc.body.textContent?.trim() || "";
    // };

    // const hasChanges =

    // contentDesc !== (originalContentData?.content_desc || "")||
    // pollQuestion !== (originalContentData?.livepollData?.question || "") ||
    // JSON.stringify(pollOptions) !== JSON.stringify(
    //   originalContentData?.livepollData?.optionData?.map((option: { option: any }) => option.option) || [""]
    // );
    // link !== (originalContentData?.link || "") ||
    // title !== (originalContentData?.content_name || "") ||
    // contentDesc !== (originalContentData?.content_desc || "")||
    // pollQuestion !== (originalContentData?.livepollData?.question || "") ||
    // JSON.stringify(pollOptions) !== JSON.stringify(
    //   originalContentData?.livepollData?.optionData?.map((option: { option: any }) => option.option) || [""]
    // ) ||
    // selectedQuiz !== originalContentData?.folder_id ||

    // showResults !== (originalContentData?.show_result === 1);

    // if (!hasChanges) {
    //   alert("No changes made.");
    //   return;
    // }

    if (!contentId) {
      setError("Training ID or Content ID is missing.");
      return;
    }

    // if (selectedModule === "Media" && !file) {
    //   setError("Please upload a file.");
    //   return;
    // }

    const incrementedOrder = order;
    const formData = new FormData();
    const payload: any = {
      id: contentId,
      // order: incrementedOrder,

      training_id: tranaingId,
      content_type: selectedModule === "Media" ? mediaType : selectedModule,
    };

    // if (selectedModule || mediaType === "Media") {
    //   payload.content_desc = contentDesc;

    //   // Ensure file is not null before appending it to formData
    //   if (file) {
    //     formData.append("content_name", file);  // File is a non-null value
    //   }
    // }

    let isValid = true; // A flag to determine if the form can be submitted

    // Check if contentDesc exceeds the character limit
    if ((selectedModule || mediaType === "Media") && contentDesc.length > 500) {
      isValid = false; // Invalidate the form if contentDesc exceeds the limit
      dispatch(showToast("Description exceeds 500 characters!")); // Show warning message
      setTimeout(() => dispatch(hideToast()), 3000);
    }

    // Proceed only if the form is valid
    if (isValid) {
      const formData = new FormData();

      payload.content_desc = contentDesc;
      payload.order = Number(numberInput);
      // Ensure file is not null before appending it to formData
      if (file) {
        formData.append("content_name", file); // Append file if available
      }
    }

    if (selectedModule === "Links") {
      payload.content_name = title;
      payload.content_type = "Survey";
      payload.link = link;
      payload.order = Number(numberInput);

      payload.id = contentId;
    }

    if (selectedModule === "Live Poll") {
      payload.content_type = "Poll";
      payload.order = Number(numberInput);

      payload.content_name = pollQuestion;
      payload.livepollData = {
        question: pollQuestion,
        optionCount: pollOptions.length,
        id: null,
      };
      payload.pollOptions = pollOptions;
      payload.show_result = showResults ? 1 : 0;
    }

    if (selectedModule === "Add Quiz") {
      const selectedFolder = folderData.find(
        (folder) => folder.id === selectedQuiz
      );
      if (selectedFolder) {
        payload.content_type = "Quiz";
        payload.order = Number(numberInput);

        payload.folder_id = selectedFolder.id;
      } else {
        setError("Please select a valid quiz.");
        return;
      }
    }

    if (selectedModule === "Text") {
      payload.content_desc = contentDesc;
      payload.order = Number(numberInput);

      payload.id = contentId;
    }

    formData.append("data", encrypt(payload));

    try {
      dispatch(showLoader("Loading data..."));
      const response = await postMultipartDetails(
        APIList.EDIT_CONTENT,
        formData
      );
      console.log("Edit Content Response:", response);

      if (response.statusCode === 200) {
        navigate(`/training/view/${tranaingId}`);
        dispatch(showToast("Successfully Edited"));
        setTimeout(() => dispatch(hideToast()), 3000);
      } else {
        // setError("Failed to edit content.");
        dispatch(
          showToast(
            "Failed to edit content Or the order you are trying to edit must be already present."
          )
        );
        setTimeout(() => dispatch(hideToast()), 3000);
      }
    } catch (err) {
      // setError("Failed to edit content.");
      dispatch(
        showToast(
          "Failed to edit content Or the order you are trying to edit must be already present."
        )
      );
      setTimeout(() => dispatch(hideToast()), 3000);
      console.error("Error editing content:", err);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    // const maxLimit = selectedModule === "Media" ? 500 : 2000;

    if (name === "content_desc") {
      // Update contentDesc and character count
      setContentDesc(value);
      setCharCount(value.length);

      // Disable the button if contentDesc exceeds the respective character limit
      if (value.length > maxLimit) {
        setIsButtonDisableds(true); // Disable button
        dispatch(showToast(`Character limit of ${maxLimit} exceeded!`));
        setTimeout(() => dispatch(hideToast()), 3000);
      } else {
        setIsButtonDisableds(false); // Enable button if within limit
      }
    } else if (name === "link") {
      setLink(value);
    } else if (name === "title") {
      setTitle(value);
    } else if (name === "pollQuestion") {
      setPollQuestion(value);
    }
  };

  // const handleFileChange = (event:any) => {
  //   const selectedFile = event.target.files[0];

  //   if (!selectedFile) return;

  //   if (!['image/jpeg', 'image/png', 'image/jpg', 'video/mp4', 'audio/mpeg', 'application/pdf'].includes(selectedFile.type)) {
  //     setError('Unsupported file type.');
  //     return;
  //   }

  //   setError('');
  //   setFile(selectedFile);
  // };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;
    setFile(file);
    setError("");

    if (file) {
      console.log("Selected file:", file);

      const allowedFileTypes = [
        "image/jpeg",
        "audio/mpeg",
        "image/jpg",
        "image/png",
        "application/pdf",
        "video/mp4",
      ];

      const disallowedExtensions = ["jfif"];

      const fileExtension = file.name.split(".").pop()?.toLowerCase();
      const fileSizeMB = file.size / (1024 * 1024);

      const sizeLimits = {
        // image: 10.5,
        // audio: 20,
        // pdf: 20,
        // video: 25,
      };

      // Validate the real extension + MIME type and reject deceptive
      // double-extension names (e.g. file.php.png, file.png.svg).
      const contentValidation = validateUploadedFile(
        file,
        {
          png: ["image/png"],
          jpg: ["image/jpeg", "image/jpg"],
          jpeg: ["image/jpeg", "image/jpg"],
          pdf: ["application/pdf"],
          mp4: ["video/mp4"],
          mp3: ["audio/mpeg"],
        },
        "JPG, JPEG, PNG, PDF, MP4 and MP3"
      );

      if (
        !contentValidation.valid ||
        !allowedFileTypes.includes(file.type) ||
        (fileExtension && disallowedExtensions.includes(fileExtension))
      ) {
        setError(
          !contentValidation.valid
            ? contentValidation.message
            : "Invalid file type. Only JPG, JPEG, PNG, PDF, MP4, and MP3 are allowed."
        );
        setFile(null);
        setIsValidFile(false);
        return;
      }

      // if (file.type.startsWith("image/") && fileSizeMB > sizeLimits.image) {
      //   setError("Image files must be smaller than 10MB.");
      //   setFile(null);
      //   setIsValidFile(false);
      //   return;
      // }

      // if (
      //   (file.type === "audio/mpeg" || file.type === "application/pdf") &&
      //   fileSizeMB > sizeLimits.audio
      // ) {
      //   setError("Audio and PDF files must be smaller than 20MB.");
      //   setFile(null);
      //   setIsValidFile(false);
      //   return;
      // }

      // if (file.type.startsWith("video/") && fileSizeMB > sizeLimits.video) {
      //   setError("Video files must be smaller than 25MB.");
      //   setFile(null);
      //   setIsValidFile(false);
      //   return;
      // }

      setIsValidFile(true);
      setFile(file);
    }
  };

  const isButtonDisabled =
    (selectedModule === "Media" && !file) ||
    (selectedModule === "Media" && !contentDesc);

  const renderPreview = () => {
    if (file) {
      const url = URL.createObjectURL(file);
      if (file.type.startsWith("image/")) {
        return (
          <img
            src={url}
            alt="Preview"
            style={{ maxWidth: "200px", marginBottom: "10px" }}
          />
        );
      }
      if (file.type.startsWith("video/")) {
        return (
          <video
            src={url}
            controls
            style={{ maxWidth: "200px", marginBottom: "10px" }}
          />
        );
      }
      if (file.type.startsWith("audio/")) {
        return <audio src={url} controls style={{ marginBottom: "10px" }} />;
      }
      if (file.type === "application/pdf") {
        return (
          <iframe
            src={url}
            style={{ width: "200px", height: "300px", marginBottom: "10px" }}
            title="PDF Preview"
          />
        );
      }
    }
    // else if (title.endsWith('jpg' || 'jpeg' || 'png')) {
    //   return <img src={title} alt="Preview" style={{ maxWidth: '200px', marginBottom: '10px' }} />;
    // }
    else if (
      title.endsWith("jpg") ||
      title.endsWith("jpeg") ||
      title.endsWith("png")
    ) {
      return (
        <img
          src={title}
          alt="Preview"
          style={{ maxWidth: "200px", marginBottom: "10px" }}
        />
      );
    } else if (title.endsWith(".mp4")) {
      return (
        <video
          src={title}
          style={{ maxWidth: "200px", marginBottom: "10px" }}
          controls
        >
          Your browser does not support the video tag.
        </video>
      );
    } else if (title.endsWith(".mp3")) {
      return (
        <audio
          src={title}
          controls
          style={{ width: "200px", marginBottom: "10px" }}
        />
      );
    } else if (title.endsWith("pdf")) {
      return (
        <iframe
          src={title}
          style={{ width: "200px", height: "300px", marginBottom: "10px" }}
          title="PDF Preview"
        />
      );
    }

    return null;
  };

  const handleAddOption = () => {
    setPollOptions([...pollOptions, ""]);
  };
  const handleShowResultsToggle = (e: any) => {
    setShowResults(e.target.checked);
  };
  const handleOptionChange = (index: number, value: string) => {
    const updatedOptions = [...pollOptions];
    updatedOptions[index] = value;
    setPollOptions(updatedOptions);
  };

  const handleRemoveOption = (index: number) => {
    setPollOptions(pollOptions.filter((_, i) => i !== index));
  };

  const handleCancel = () => {
    navigate(`/training/view/${tranaingId}`);
  };

  const buttons = [
    {
      label: "Back to Content",
      theme: "danger",
      icon: <HiArrowSmallLeft />,
      onClick: handleCancel,
    },
  ];

  return (
    <LayoutContainer title={"Edit Content"}>
      <div className="page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon fa fa-list"></i>
          Edit Content
        </h2>
        <PageHeader buttons={buttons} />
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      <Form className="add-conect-form" onSubmit={handleSubmit}>
        <Form.Group>
          <Form.Label className="header-add-content">
            Select Module to Add
          </Form.Label>
          <Form.Control
            as="select"
            value={selectedModule}
            onChange={(e) => setSelectedModule(e.target.value)}
            required
          >
            <option value="Please Select">Please Select</option>
            <option value="Text">Text</option>
            <option value="Links">Links</option>
            <option value="Media">Media</option>
            <option value="Add Quiz">Add Quiz</option>
            <option value="Live Poll">Live Poll</option>
          </Form.Control>
        </Form.Group>

        {selectedModule === "Media" && (
          <>
            <Form.Group className="media-select">
              <Form.Label className="header-add-content">
                Upload File
              </Form.Label>

              {/* Show existing image if available */}
              <div>
                {renderPreview()}
                <div className="position-relative">
                  <Form.Control
                    type="file"
                    accept=".mp3, .mp4, .jpg, .jpeg, .png, .pdf"
                    onChange={handleFileChange}
                    required={!file && !title}
                  />
                </div>
                {error && <div className="text-danger">{error}</div>}
              </div>
            </Form.Group>
            {/* <EditorField
  name="content_desc"
  label="Description"
  type="text"
  value={contentDesc}
  placeholder="Enter Description"
  minLength={3}
  maxLength={maxLimit}
  required
  onChangeInput={handleInputChange} // Pass the function directly
/> */}
            <div className="d-flex flex-column gap-2 mb-5">
              <label htmlFor="post_status" className="fw-medium">
                Post
              </label>
              <div className="editor-container">
                <CKEditor
                  editor={ClassicEditor as any}
                  data={contentDesc}
                  // config={{
                  //   placeholder: "Enter Post",
                  //   link: {
                  //     defaultProtocol: "https://", // Ensures https:// is added to links without protocol
                  //     addTargetToExternalLinks: true,
                  //   },
                  //   toolbar: [
                  //     "heading",
                  //     "|",
                  //     "bold",
                  //     "italic",
                  //     "link",
                  //     "bulletedList",
                  //     "numberedList",
                  //     "insertTable",
                  //     "blockQuote",
                  //     "undo",
                  //     "redo",
                  //   ],
                  //   image: {
                  //     toolbar: [
                  //       "imageTextAlternative",
                  //       "imageStyle:full",
                  //       "imageStyle:side",
                  //     ],
                  //   },
                  //   table: {
                  //     contentToolbar: [
                  //       "tableColumn",
                  //       "tableRow",
                  //       "mergeTableCells",
                  //     ], // Options to edit tables
                  //   },
                  //   removePlugins: [
                  //     "EasyImage",
                  //     "ImageToolbar",
                  //     "ImageCaption",
                  //     "ImageStyle",
                  //     "MediaEmbed",
                  //   ],
                  //   extraPlugins: [],
                  // }}
                  onChange={handleEditorChange}
                />
              </div>
            </div>
            <div className="character-count text-end">
              {charCount}/{500}
            </div>
            {/* 
<EditorField
           name="content_desc"
           value={contentDesc}
           
               type="text"
           
           onChangeInput={handleInputChange}
          
         /> */}

            {/* <CKEditor
        editor={ClassicEditor}
        data={contentDesc}
        onChange={handleEditorChange}
        config={{
          placeholder: 'Enter Description',
          // minLength: 3,
          // maxLength: 500
        }}
      />*/}
            {/* <div className="character-count text-end">
            {charCount}/{500}
          </div>  */}

            <Form.Group className="number-input">
              <Form.Label className="header-add-content">
                Enter Order
              </Form.Label>
              <Form.Control
                type="number"
                value={numberInput}
                onChange={(e: any) => setNumberInput(e.target.value)}
                placeholder="Enter a number"
                max={99}
                onWheel={(e: any) => e.target.blur()}
              />
            </Form.Group>
          </>
        )}

        {selectedModule === "Links" && (
          <>
            <Form.Group>
              <Form.Label className="header-add-content">Title</Form.Label>
              <Form.Control
                type="text"
                name="title"
                value={title}
                onChange={handleInputChange}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label className="header-add-content">Link</Form.Label>
              <Form.Control
                type="text"
                name="link"
                value={link}
                onChange={handleInputChange}
                required
              />
            </Form.Group>
            <Form.Group className="number-input">
              <Form.Label className="header-add-content">
                Enter Order
              </Form.Label>
              <Form.Control
                type="number"
                value={numberInput}
                onChange={(e: any) => setNumberInput(e.target.value)}
                placeholder="Enter a number"
                max={99}
                onWheel={(e: any) => e.target.blur()}
              />
            </Form.Group>
          </>
        )}

        {selectedModule === "Live Poll" && (
          <>
            <Form.Group>
              <Form.Group controlId="showResults" className="mt-3">
                <Form.Check
                  type="checkbox"
                  label="Show Results"
                  checked={showResults}
                  onChange={handleShowResultsToggle}
                />
              </Form.Group>
              <Form.Label className="header-add-content">
                Poll Question
              </Form.Label>
              {/* <Form.Control
                type="text"
                name="pollQuestion"
                value={pollQuestion}
                onChange={handleInputChange}
                required
              /> */}

              <div>
                <textarea
                  name="pollQuestion"
                  value={pollQuestion}
                  maxLength={500}
                  required={true}
                  onChange={handleInputChange}
                  rows={3}
                  className="poll-box"
                />
              </div>
            </Form.Group>
            {pollOptions.map((option, index) => (
              <Form.Group key={index}>
                <Form.Label className="header-add-content">
                  Option {index + 1}
                </Form.Label>
                <div className="d-flex">
                  <Form.Control
                    type="text"
                    value={option}
                    name={option}
                    onChange={(e) => handleOptionChange(index, e.target.value)}
                    required
                  />
                  <Button
                    variant="danger"
                    onClick={() => handleRemoveOption(index)}
                  >
                    Remove
                  </Button>
                </div>
              </Form.Group>
            ))}
            <div className="edit-add-content mt-3">
              <Button variant="success" onClick={handleAddOption}>
                Add Option
              </Button>
            </div>
            <Form.Group className="number-input">
              <Form.Label className="header-add-content">
                Enter Order
              </Form.Label>
              <Form.Control
                type="number"
                value={numberInput}
                onChange={(e: any) => setNumberInput(e.target.value)}
                placeholder="Enter a number"
                max={99}
                onWheel={(e: any) => e.target.blur()}
              />
            </Form.Group>
          </>
        )}

        {selectedModule === "Add Quiz" && (
          <>
            <Form.Group>
              <Form.Label className="header-add-content">
                Select Quiz
              </Form.Label>
              <Form.Control
                as="select"
                value={selectedQuiz ?? ""}
                onChange={(e) => setSelectedQuiz(Number(e.target.value))}
                required
              >
                <option value="">Select Quiz</option>
                {folderData.map((folder) => (
                  <option key={folder.id} value={folder.id}>
                    {folder.folder_name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group className="number-input">
              <Form.Label className="header-add-content">
                Enter Order
              </Form.Label>
              <Form.Control
                type="number"
                value={numberInput}
                onChange={(e: any) => setNumberInput(e.target.value)}
                placeholder="Enter a number"
                max={99}
                onWheel={(e: any) => e.target.blur()}
              />
            </Form.Group>
          </>
        )}

        {selectedModule === "Text" && (
          <Form.Group>
            <Form.Label className="header-add-content">Description</Form.Label>
            {/* <Form.Control
              as="textarea"
              name="content_desc"
              value={contentDesc}
              onChange={handleInputChange}
              rows={3}
              required
            /> */}
            <>
              {/* <EditorField
           name="content_desc"
           value={contentDesc}
           
               type="text"
           
           onChangeInput={handleInputChange}
          
         /> */}
              <EditorField
                name="content_desc"
                label="Description"
                type="text"
                value={contentDesc}
                placeholder="Enter Description"
                minLength={3}
                maxLength={selectedModule === "Text" ? 500 : 2000}
                required
                onChangeInput={handleInputChange} // Pass the function directly
              />
              <div className="character-count text-end">
                {charCount}/{2000}
              </div>
              <Form.Group className="number-input">
                <Form.Label className="header-add-content">
                  Enter Order
                </Form.Label>
                <Form.Control
                  type="number"
                  value={numberInput}
                  onChange={(e: any) => setNumberInput(e.target.value)}
                  placeholder="Enter a number"
                  max={99}
                  onWheel={(e: any) => e.target.blur()}
                />
              </Form.Group>
            </>
          </Form.Group>
        )}

        <div className="d-flex justify-content-between mt-3">
          {/* <Button variant="warning" type="submit" disabled={isButtonDisabled}>Save Changes</Button> */}
          <Button variant="warning" type="submit" disabled={isButtonDisableds}>
            Save Changes
          </Button>
          <Button variant="secondary" onClick={handleCancel}>
            Cancel
          </Button>
        </div>
      </Form>
    </LayoutContainer>
  );
};

export default EditContentForm;
